import React from 'react';

function Libya(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124067)">
        <mask
          id="mask0_800_124067"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124067)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 18H36V24H0V18Z"
            fill="#55BA07"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 6H36V18H0V6Z"
            fill="#1D1D1D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V6H0V0Z"
            fill="#E11C1B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7721 15.0659C15.756 14.6955 15.233 13.7578 15.2546 12.3114C15.2546 10.7808 16.1613 9.23167 17.7516 9.06231C19.342 8.89295 20.6445 9.42027 21.3273 10.1561C20.7562 8.15862 18.8645 7.94015 17.412 7.94015C15.2252 7.92316 12.9824 9.4002 12.9824 12.1787C12.9824 14.5994 14.9593 16.4194 17.4751 16.4644C20.6204 16.4644 21.1126 14.5338 21.2031 13.8761C21.0212 13.9921 20.852 14.1305 20.6783 14.2727C20.0458 14.7902 19.3538 15.3565 17.7721 15.0659ZM22.7958 11.2912L21.3064 11.7078L22.9743 12.2879L22.7421 13.8419L23.8725 12.7726L25.5126 13.0728L24.4044 11.921L25.3855 10.744L24.0157 11.0009L23.0478 10.0287L22.7958 11.2912Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124067">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Libya;
